{
    angular.module('interfaceModule')
        .controller('RefundController',RefundController);
    RefundController.$inject = ['$scope','request.order','utils.constant','$stateParams',
    "utils.currentUser",'$state','utils.common',
    'utils.refundUploadManager',];
    function RefundController($scope,orderRequest,constant,$stateParams,
    	currentUser,$state,common,refundUploadManager) {
        let vm=this;
        let collect={
            'activate':activate,
            'docInfo':null,
            'printInfo':null,
            'orderInfo':null,
            'refundSubmit':refundSubmit,
            'refundReason':'',
            'refundDesc':'',
            'uploader':null,
            'imageList':[]
        };

        vm.collect=collect;
        activate();

		function activate(){
        	//console.log($stateParams);

            initUploader();

			if(currentUser.info){
                getOrderInfo()
            }else{
                let destructor=$scope.$on('user.logged',function(event,data){
                    getOrderInfo();
                    destructor();
                });
            }
            
            
        }

        function initUploader(){
            refundUploadManager.init();
            collect.uploader=refundUploadManager.uploader;
            collect.imageList=refundUploadManager.imageList;
            //console.log(collect.uploader)
            let delegate={};
            delegate.onWhenAddingFileFailed = function(item , filter, options) {
                common.prompt('文件上传失败，请确认所传文件是否符合要求');
            };
            delegate.onAfterAddingFile = function(fileItem) {
                console.log('开始上传');
            };
            delegate.onSuccessItem = function(fileItem, response, status, headers) {
                
            };
            delegate.onErrorItem = function(fileItem, response, status, headers) {
                common.alert('文件上传失败');
                
            };
            delegate.onCompleteItem = function(fileItem, response, status, headers) {
                // console.info('onCompleteItem', fileItem, response, status, headers);
                console.log('结束上传');
            };

            refundUploadManager.callbackDelegateList.push(delegate);
            $scope.$on("$destroy", function(e) {
                refundUploadManager.callbackDelegateList
                    .splice(refundUploadManager.callbackDelegateList.indexOf(delegate),1);
                delegate=null;
            })
        }


        function getOrderInfo(){
            // common.loading.show();
            orderRequest.getOrderInfo($stateParams.orderId)
            .then(function(data){
                //console.log(data);
                collect.docInfo=data.docInfo;
                collect.printInfo=data.printInfo;
                collect.orderInfo=data.orderInfo;

            })
        }

        function refundSubmit(){
            if(collect.refundReason==''){
                common.alert("申请退款","请选择退款原因");
            }else if(collect.orderInfo.status==4&&collect.imageList.length<=0){
                common.alert("申请退款","请上传照片");
            }
            else{
                common.loading.show();
            	orderRequest.refundApply(collect.orderInfo.orderId,
            		collect.orderInfo.orderPrintId,
            		collect.refundReason,
            		collect.refundDesc,
            		collect.imageList)
            	.then(function(date){
                    common.loading.hide();
                    if(date[0].result==1){
                        $state.go('main.refundDetail',{'orderId':collect.orderInfo.orderId});
                    }
                    
            	},
                function(){
                    common.loading.hide();
                })
            }
        }
    }
    
}